/**
 * Identidad del producto.
 *
 * @module config/producto
 */

import { env } from './env'

export const PRODUCTO = {
  nombre: env.APP_NAME,
  descriptor: 'Sistema de información para servicios de imágenes diagnósticas',
  descripcion:
    'Agenda, lista de trabajo, informes firmados, portal del paciente y visor integrado',
} as const

export const MODULOS_EN_PRODUCCION = [
  'Pacientes',
  'Agenda y citas',
  'Estudios e imágenes',
  'Informes y firma',
  'Transcripción',
  'Auditoría',
] as const
